import { LANDING_ROUTES } from '@cyberkongz/ui';
import { BLUEPRINT_ITEMS, BlueprintLayout } from '@features/blueprint/BlueprintLayout';
import { GetStaticPropsContext, InferGetStaticPropsType } from 'next';
import { ParsedUrlQuery } from 'querystring';
import React from 'react';

export default function BlueprintPage({ tabId }: InferGetStaticPropsType<typeof getStaticProps>) {
  return <BlueprintLayout tabId={tabId} />;
}

export async function getStaticProps({ params }: GetStaticPropsContext) {
  const tabSlugQuery = (params as ParsedUrlQuery).tabSlug as string;
  const tabSlugIndex = BLUEPRINT_ITEMS.findIndex(({ slug }) => slug === tabSlugQuery);

  return {
    notFound: tabSlugIndex < 0,
    props: {
      tabId: BLUEPRINT_ITEMS[tabSlugIndex].id,
    },
  };
}

export async function getStaticPaths() {
  return {
    paths: BLUEPRINT_ITEMS.map(({ slug }) => LANDING_ROUTES.BLUEPRINT_TAB(slug)),
    fallback: 'blocking',
  };
}
